import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import EmailFetchAccountsSettingsForm from './EmailFetchAccountsSettingsForm';
import i18n from 'i18n';

interface EmailFetchAccountsSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeEmailFetchAccount: number;
}

const EmailFetchAccountsSettingsModal: React.FC<EmailFetchAccountsSettingsModalProps> = React.memo(({
    modalOpen,
    closeModal,
    activeEmailFetchAccount,
}) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_email_fetch_accounts_settings.text')}
        entityId={activeEmailFetchAccount}
        FormComponent={EmailFetchAccountsSettingsForm}
    />
));

export default EmailFetchAccountsSettingsModal; 